import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=2a73293f&scoped=true"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"
import style0 from "./unauthorized.vue?vue&type=style&index=0&id=2a73293f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73293f",
  null
  
)

export default component.exports